'use client';

import { ErrorMessageDisplay } from '@/ui/ErrorMessage';

export default function Error({
  error,
  reset,
}: {
  error?: Error & { digest?: string };
  reset?: () => void;
}) {
  return <ErrorMessageDisplay error={error} reset={reset} />;
}
